import i18n from '@/plugins/i18n'

export function required (value) {
    return ((value ?? '') !== '') || i18n.t('validator.required')
}
